import { IoMdRocket } from "react-icons/io";
import { toast } from "react-toastify";
export default function TriggerHighDemandToast() {
  toast.dismiss();

  return toast(
    <div>
      <div className="row">
        <div className="col-2 mg-t-5">{<IoMdRocket size={32} />}</div>
        <div className="col-10">
          Estamos com uma alta demanda em nossa I.A no momento, por favor,
          aguarde um momento por sua análise.
        </div>
      </div>
    </div>,
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeButton: true,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
      theme: "dark",
      progressStyle: {
        backgroundColor: "#596EFD",
      },
    }
  );
}
